module.exports = __webpack_public_path__ + "static/img/ent-78.a1f76e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-78.jpg
// module id = 9M4S
// module chunks = 52